// Shared helpers for the "Activity" comment threads used on both the Board's
// TaskDialog and the Ticket form, so both stay visually/behaviorally consistent.

export const COMMENT_SUGGESTIONS = ["Status update...", "Thanks...", "Agree..."];
export const IMAGE_SIZE_PRESETS = { small: 25, medium: 50, large: 100 };
export const IMAGE_SIZE_ORDER = ["small", "medium", "large"];

export const initialsOf = (name) =>
  (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "?";

export const formatCommentTime = (dateString) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

export const escapeHtml = (text) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

// Wraps "@Full Name" occurrences (for known team members) in a highlight span.
export const highlightMentions = (html, members) => {
  if (!html) return html;

  return members
    .slice()
    .sort((a, b) => (b.employee_name?.length || 0) - (a.employee_name?.length || 0))
    .reduce((result, member) => {
      if (!member.employee_name) return result;
      const escapedName = member.employee_name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const pattern = new RegExp(`@${escapedName}(?!\\w)`, "g");
      return result.replace(pattern, `<span class="mention-highlight">@${member.employee_name}</span>`);
    }, html);
};
